import { Routes } from '@angular/router';
import {
  isChildRouteAllowed,
  isFeatureAllowed,
  isRouteNavigationAllowed,
} from './auth/auth-guard/auth-guard';
import { NoAccessComponent } from './components/no-access/no-access.component';
import { CpRoutes } from './cp-route-constants';
export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: CpRoutes.NewDashboard,
        canActivate: [isRouteNavigationAllowed],
        loadComponent: () =>
          import('./components/new-dashboard/dashboard.component').then(
            (c) => c.DashboardComponent
          ),
      },
      {
        path: CpRoutes.RealtimeDashboard,
        canActivate: [isRouteNavigationAllowed],
        loadComponent: () =>
          import(
            './components/realtime-dashboard/realtime-dashboard.component'
          ).then((c) => c.RealtimeDashboardComponent),
      },
      {
        path: 'auth',
        redirectTo: '',
      },
      {
        path: CpRoutes.ReturnDetails,
        canActivate: [isRouteNavigationAllowed],
        loadComponent: () =>
          import('./components/return-metrics/return-metrics.component').then(
            (c) => c.ReturnMetricsComponent
          ),
      },
      /*{
        path: CpRoutes.RealtimeDashboard,
        canActivate: [isRouteNavigationAllowed],
        loadComponent: () =>
          import(
            './components/realtime-dashboard/realtime-dashboard.component'
          ).then((c) => c.RealtimeDashboardComponent),
      },*/
      {
        path: CpRoutes.TransportDashboard,
        canActivate: [isRouteNavigationAllowed],
        loadComponent: () =>
          import(
            './components/transport-dashboard/transport-dashboard.component'
          ).then((c) => c.TransportDashboardComponent),
      },
      {
        path: CpRoutes.PaxonDashboard,
        canActivate: [isRouteNavigationAllowed],
        loadComponent: () =>
          import(
            './components/paxon-dashboard/paxon-dashboard.component'
          ).then((c) => c.PaxonDashboardComponent),
      },
      {
        path: CpRoutes.ReportBuilder,
        canActivate: [isRouteNavigationAllowed],
        loadComponent: () =>
          import('./components/report-builder/report-builder.component').then(
            (c) => c.ReportBuilderComponent
          ),
      },
      {
        path: CpRoutes.OntimeShipSLA,
        canActivate: [isRouteNavigationAllowed],
        loadComponent: () =>
          import('./components/sla/summery-view/sla.component').then(
            (c) => c.SlaComponent
          ),
      },
      {
        path: CpRoutes.OntimeShipSLAList,
        canActivate: [isChildRouteAllowed],
        loadComponent: () =>
          import('./components/sla/list-view/list-view.component').then(
            (c) => c.ListViewComponent
          ),
        data: {
          parent_route: CpRoutes.OntimeShipSLA,
        },
      },
      {
        path: CpRoutes.HistoricDashboard,
        canActivate: [isRouteNavigationAllowed],
        loadComponent: () =>
          import(
            './components/historic-dashboard/historic-dashboard.component'
          ).then((c) => c.HistoricDashboardComponent),
      },
      {
        path: CpRoutes.InventoryDetails,
        canActivate: [isRouteNavigationAllowed],
        loadComponent: () =>
          import(
            './components/inventory-details/inventory-details.component'
          ).then((c) => c.InventoryDetailsComponent),
      },
      {
        path: CpRoutes.InventoryDetailsInfo,
        canActivate: [isChildRouteAllowed],
        loadComponent: () =>
          import(
            './components/inventory-details/inventory-detail-info/inventory-detail-info.component'
          ).then((c) => c.InventoryDetailInfoComponent),
        data: {
          parent_route: CpRoutes.InventoryDetails,
        },
      },
      {
        path: CpRoutes.PurchaseOrderDetails,
        canActivate: [isRouteNavigationAllowed],
        loadComponent: () =>
          import('./components/inbound-metrics/inbound-metrics.component').then(
            (c) => c.InboundMetricsComponent
          ),
      },
      {
        path: CpRoutes.OrderDetails,
        canActivate: [isRouteNavigationAllowed],
        loadComponent: () =>
          import(
            './components/outbound-metrics/outbound-metrics.component'
          ).then((c) => c.OutboundMetricsComponent),
      },
      {
        path: CpRoutes.OrderDetailsInfo,
        canActivate: [isChildRouteAllowed],
        loadComponent: () =>
          import(
            './components/outbound-metrics/outbound-order-details/outbound-order-details.component'
          ).then((c) => c.OutboundOrderDetailsComponent),
        data: {
          parent_route: CpRoutes.OrderDetails,
        },
      },
      {
        path: CpRoutes.OrdersOnHold,
        canActivate: [isRouteNavigationAllowed],
        loadComponent: () =>
          import('./components/order-viability/order-viability.component').then(
            (c) => c.OrderViabilityComponent
          ),
      },
      {
        path: CpRoutes.OrdersOnHoldInfo,
        loadComponent: () =>
          import(
            './components/order-viability/order-viability-order-detail/order-viability-order-detail.component'
          ).then((c) => c.OrderViabilityOrderDetailComponent),
      },
      {
        path: CpRoutes.OrdersOnHoldBlockRequests,
        canActivate: [isFeatureAllowed],
        loadComponent: () =>
          import(
            './components/order-viability/order-block-requests/order-block-requests.component'
          ).then((c) => c.OrderBlockRequestsComponent),
        data: {
          parent_route: CpRoutes.OrdersOnHold,
          acronym: CpRoutes.BlockRequestsAcronym,
        },
      },
      {
        path: CpRoutes.Kitting,
        canActivate: [isRouteNavigationAllowed],
        loadComponent: () =>
          import('./components/kitting/kitting.component').then(
            (c) => c.KittingComponent
          ),
      },
      {
        path: CpRoutes.KittingOrderDetail,
        // canActivate: [isFeatureAllowed],
        loadComponent: () =>
          import(
            '././components/kitting/kitting-order-details/kitting-order-details.component'
          ).then((c) => c.KittingOrderDetailsComponent),
      },
      {
        path: CpRoutes.KittingOrdersImport,
        // canActivate: [isFeatureAllowed],
        loadComponent: () =>
          import(
            '././components/kitting/kitting-orders-import/kitting-orders-import.component'
          ).then((c) => c.KittingOrdersImportComponent),
      },
      {
        path: CpRoutes.AddItem,
        canActivate: [isFeatureAllowed],
        loadComponent: () =>
          import('./shared/components/add-item/add-item.component').then(
            (c) => c.AddItemComponent
          ),
        data: {
          acronym: CpRoutes.AddItemAcronym,
        },
      },
      {
        path: CpRoutes.SitePlanningForecast,
        canActivate: [isFeatureAllowed],
        loadComponent: () =>
          import('./components/forecast/forecast.component').then(
            (c) => c.ForecastComponent
          ),
        data: { acronym: CpRoutes.FcSiteAcronym, type: 'site' },
      },
      {
        path: CpRoutes.VolumeForecast,
        canActivate: [isFeatureAllowed],
        loadComponent: () =>
          import('./components/forecast/forecast.component').then(
            (c) => c.ForecastComponent
          ),
        data: { acronym: CpRoutes.FcVolumeAcronym, type: 'volume' },
      },
      {
        path: CpRoutes.PeakForecast,
        loadComponent: () =>
          import('./components/forecast/forecast.component').then(
            (c) => c.ForecastComponent
          ),
        data: { acronym: CpRoutes.FcPeakAcronym, type: 'peak' },
      },
      {
        path: CpRoutes.SitePlanningForecastSearch,
        canActivate: [isFeatureAllowed],
        loadComponent: () =>
          import(
            './components/forecast/search-forecast/search-forecast.component'
          ).then((c) => c.SearchForecastComponent),
        data: { acronym: CpRoutes.FcSiteAcronym, type: 'site' },
      },
      {
        path: CpRoutes.VolumeForecastSearch,
        canActivate: [isFeatureAllowed],
        loadComponent: () =>
          import(
            './components/forecast/search-forecast/search-forecast.component'
          ).then((c) => c.SearchForecastComponent),
        data: { acronym: CpRoutes.FcVolumeAcronym, type: 'volume' },
      },
      {
        path: CpRoutes.PeakForecastSearch,
        loadComponent: () =>
          import(
            './components/forecast/search-forecast/search-forecast.component'
          ).then((c) => c.SearchForecastComponent),
        data: { acronym: CpRoutes.FcPeakAcronym, type: 'peak' },
      },
      {
        path: CpRoutes.InquiryDesk,
        canActivate: [isRouteNavigationAllowed],
        loadComponent: () =>
          import(
            './components/client-case-management/client-inquiry-view/client-inquiry-view.component'
          ).then((c) => c.ClientInquiryViewComponent),
      },
    ],
  },
  {
    path: 'no-access',
    canActivate: [],
    component: NoAccessComponent,
  },
  {
    path: '**',
    canActivate: [],
    component: NoAccessComponent,
  },
];
